import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import t from '../../lib/I18n';
import FormattedHTMLMessage from '../general/FormattedHTMLMessage';

const RegisterHello = ({ className, name }) => {
    return (
        <div className={ classnames('register-modal__success-message', className) }>
            <FormattedHTMLMessage
                className="register-modal__success-message__html"
                message="account.register.successMessage"
                name={ name }
                brand={ t('app.owner.short') }
                />
        </div>
    );
};

RegisterHello.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string
};

RegisterHello.defaultProps = {
    className: '',
    name: ''
};

export default RegisterHello;



// WEBPACK FOOTER //
// ./src/components/login/RegisterHello.js